export const IAM_DOCTOR_LOGIN_REQUESTED = 'IAM_DOCTOR_LOGIN_REQUESTED';
export const IAM_DOCTOR_LOGIN_SUCCESS = 'IAM_DOCTOR_LOGIN_SUCCESS';
export const IAM_DOCTOR_LOGIN_FAILED = 'IAM_DOCTOR_LOGIN_FAILED';

export const IAM_LIMITED_DEVICE_LOGIN_REQUESTED = 'IAM_LIMITED_DEVICE_LOGIN_REQUESTED';
export const IAM_LIMITED_DEVICE_LOGIN_SUCCESS = 'IAM_LIMITED_DEVICE_LOGIN_SUCCESS';
export const IAM_LIMITED_DEVICE_LOGIN_FAILED = 'IAM_LIMITED_DEVICE_LOGIN_FAILED';

export const IAM_VERIFY_OTP_REQUESTED = 'IAM_VERIFY_OTP_REQUESTED';
export const IAM_VERIFY_OTP_SUCCESS = 'IAM_VERIFY_OTP_SUCCESS';
export const IAM_VERIFY_OTP_FAILED = 'IAM_VERIFY_OTP_FAILED';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const UPDATE_ACCESS_TOKEN_REQUESTED = 'UPDATE_ACCESS_TOKEN_REQUESTED';
export const UPDATE_ACCESS_TOKEN_SUCCESS = 'UPDATE_ACCESS_TOKEN_SUCCESS';
export const UPDATE_ACCESS_TOKEN_FAILED = 'UPDATE_ACCESS_TOKEN_FAILED';

export const REGISTER_NOTIFICATION_TOKEN = 'REGISTER_NOTIFICATION_TOKEN';
export const UNREGISTER_NOTIFICATION_TOKEN = 'UNREGISTER_NOTIFICATION_TOKEN';

export const IAM_USER_DETAILS_REQUESTED = 'IAM_USER_DETAILS_REQUESTED';
export const IAM_USER_DETAILS_SUCCESS = 'IAM_USER_DETAILS_SUCCESS';
export const IAM_USER_DETAILS_FAILED = 'IAM_USER_DETAILS_FAILED';

export const AUTH_OTP_RESEND_REQUEST_REQUESTED = 'AUTH_OTP_RESEND_REQUEST_REQUESTED';
export const AUTH_OTP_RESEND_REQUEST_SUCCESS = 'AUTH_OTP_RESEND_REQUEST_SUCCESS';
export const AUTH_OTP_RESEND_REQUEST_FAILED = 'AUTH_OTP_RESEND_REQUEST_FAILED';

export const IAM_CHANGE_PASSWORD_REQUESTED = 'IAM_CHANGE_PASSWORD_REQUESTED';
export const IAM_CHANGE_PASSWORD_SUCCESS = 'IAM_CHANGE_PASSWORD_SUCCESS';
export const IAM_CHANGE_PASSWORD_FAILED = 'IAM_CHANGE_PASSWORD_FAILED';
